export class CodeConfirmationModel {
    email: string;
    code: string;
}

export class ChangePassword {
    oldPassword?: string;
    newPassword?: string;
}



// WEBPACK FOOTER //
// ./src/webportal/models/user/user.ts